export const POSICOES_OBRIGATORIAS_VEICULO = ["frente", "traseira", "lateral_esquerda", "lateral_direita"] as const;
export const POSICOES_OPCIONAIS_VEICULO = ["motor", "painel_interno"] as const;
export const POSICOES_VEICULO = [...POSICOES_OBRIGATORIAS_VEICULO, ...POSICOES_OPCIONAIS_VEICULO] as const;
export type PosicaoVeiculo = (typeof POSICOES_VEICULO)[number];
export const ROTULO_POSICAO_VEICULO: Record<PosicaoVeiculo, string> = {
  frente: "Frente",
  traseira: "Traseira",
  lateral_esquerda: "Lateral esquerda",
  lateral_direita: "Lateral direita",
  motor: "Motor",
  painel_interno: "Painel/Interno",
};
export const posicaoOpcionalVeiculo = (posicao: PosicaoVeiculo): boolean =>
  (POSICOES_OPCIONAIS_VEICULO as readonly string[]).includes(posicao);

export const ehPosicaoVeiculo = (valor: unknown): valor is PosicaoVeiculo =>
  typeof valor === "string" && (POSICOES_VEICULO as readonly string[]).includes(valor);

export function posicoesFaltantes(fotos: readonly { posicao: string }[]): PosicaoVeiculo[] {
  const presentes = new Set(fotos.map((foto) => foto.posicao));
  return POSICOES_OBRIGATORIAS_VEICULO.filter((posicao) => !presentes.has(posicao));
}

export const mensagemFotosFaltantes = (faltam: PosicaoVeiculo[]): string =>
  `Faltam fotos do veículo: ${faltam.map((posicao) => ROTULO_POSICAO_VEICULO[posicao].toLowerCase()).join(", ")}.`;

type Perfil = { empresaId?: string | null; roles?: string[] | null; ativo?: boolean };

function acesso(
  perfil: Perfil,
  veiculo: { parceiroId: string },
  vistoriadoraId: string | null | undefined,
  papeisEquipe: string[],
): boolean {
  if (perfil.ativo === false) return false;
  if (perfil.roles?.includes("owner")) return true;
  if (!perfil.empresaId) return false;
  if (perfil.empresaId === veiculo.parceiroId) return true;
  return !!vistoriadoraId && perfil.empresaId === vistoriadoraId &&
    !!perfil.roles?.some((role) => papeisEquipe.includes(role));
}

/** Mesmo critério de pode_acessar_veiculo_do_parceiro no banco. */
export const podeEditarFotosVeiculo = (perfil: Perfil, veiculo: { parceiroId: string }, vistoriadoraId: string | null | undefined): boolean =>
  acesso(perfil, veiculo, vistoriadoraId, ["admin", "tv", "rt"]);

/** Cadastro: dono, owner ou admin da vistoriadora do parceiro. */
export const podeAlterarCadastroVeiculo = (perfil: Perfil, veiculo: { parceiroId: string }, vistoriadoraId: string | null | undefined): boolean =>
  acesso(perfil, veiculo, vistoriadoraId, ["admin"]);

/** Antecipação do trigger trg_laudo_detran_2_exigir_fotos. */
export function bloqueioAtribuicaoTv(
  laudo: { moduloDetranVeiculoFoto: boolean; tecnicoVistoriaId: string | null },
  novoTecnicoId: string | null | undefined,
  fotos: readonly { posicao: string }[],
): string | null {
  if (!novoTecnicoId || laudo.tecnicoVistoriaId || !laudo.moduloDetranVeiculoFoto) return null;
  const faltam = posicoesFaltantes(fotos);
  return faltam.length ? mensagemFotosFaltantes(faltam) : null;
}
